'use client';

import { useGardenPlannerStore } from '@shared/store/useGardenPlannerStore';
import { useUpdateGarden } from '@api/gardens';
import { useGarden } from '@modules/garden-planner/context/garden_planner_context';
import { createHandleClearAllPlants } from '@modules/garden-planner/sidebar/clear_plants_tool/business_logic';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface ClearPlantsToolContainerProps {
  views: GardenPlannerViews;
}

export function ClearPlantsToolContainer({ views }: ClearPlantsToolContainerProps) {
  const { ClearPlantsToolView } = views;
  const isClearMode = useGardenPlannerStore((state) => state.isClearMode);
  const setActiveMode = useGardenPlannerStore((state) => state.setActiveMode);
  const garden = useGarden();
  const updateGarden = useUpdateGarden();
  const handleClearAllPlants = createHandleClearAllPlants(garden, updateGarden);
  const handleToggle = () => setActiveMode(isClearMode ? null : 'clear');

  return (
    <ClearPlantsToolView
      isActive={isClearMode}
      onToggle={handleToggle}
      onClearAllPlants={handleClearAllPlants}
    />
  );
}
